<template>
    <div>
        <vs-row style="direction:ltr;">
            <vs-button class="mb-4 float-right" type="flat" @click="addAcademy()">افزودن آکادمی</vs-button>
        </vs-row>
        <div class="items-grid-view vx-row match-height" v-if="academy.items.length" appear>
            <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full" v-for="item in academy.items" :key="item.id">

                <vx-card class="grid-view-item mb-base overflow-hidden">
                    <template slot="no-body">
                        <div class="item-img-container bg-white h-64 flex items-center justify-center mb-4 cursor-pointer">
                            <img v-if="item.thumb" :src="srcFile(item.thumb)" :alt="item.caption" class="grid-view-img px-4">
                            <img v-else src="./../../../../assets/images/logo/logo.png" class="grid-view-img px-4">
                        </div>
                        <div class="item-details px-4">
                            <div class="my-4">
                                <h6 class="truncate font-semibold mb-1 hover:text-primary cursor-pointer">{{ item.caption }}</h6>
                            </div>
                        </div>

                        <div class="flex flex-wrap">

                            <div class="item-view-primary-action-btn p-3 flex flex-grow items-center justify-center cursor-pointer" @click="deleteAcademy(item.id)">
                                <feather-icon icon="XIcon" svgClasses="h-4 w-4" />

                                <span class="text-sm font-semibold ml-2">حذف</span>
                            </div>
                            <div class="item-view-primary-action-btn p-3 flex flex-grow items-center justify-center cursor-pointer" @click="editAcademy(item.id)">
                                <feather-icon icon="EditIcon" svgClasses="h-4 w-4" />

                                <span class="text-sm font-semibold ml-2">ویرایش</span>
                            </div>

                            <div class="item-view-secondary-action-btn bg-primary p-3 flex flex-grow items-center justify-center text-white cursor-pointer"  @click="openVideo(item.index)">
                                <feather-icon icon="EyeIcon" svgClasses="h-4 w-4" />

                                <span class="text-sm font-semibold ml-2">مشاهده</span>
                            </div>
                        </div>
                    </template>
                </vx-card>

            </div>

            <div>
                <LightBox
                    ref="lightbox"
                    :media="academy.items"
                    :show-caption="true"
                    :show-light-box="false"
                    :auto-play="true"
                    :disableScroll="false"
                />
            </div>

        </div>

        <div v-else>
            <h3>آکادمی موجود نیست...</h3>
        </div>

        <AddAcademy :popupAddAcademy='popupAddAcademy' @updatePopupAddAcademy='updatePopupAddAcademy'/>

        <EditAcademy :popupEditAcademy='popupEditAcademy' :academyId='editAcademyId' @updatePopupEditAcademy='updatePopupEditAcademy'/>

        <DeleteAcademy :popupDeleteAcademy='popupDeleteAcademy' :academyId='deleteAcademyId' @updatePopupDeleteAcademy='updatePopupDeleteAcademy'/>

    </div>
</template>

<script>
import AddAcademy from './Add'
import EditAcademy from './Edit'
import DeleteAcademy from './Delete'

import LightBox from 'vue-it-bigger'
require('vue-it-bigger/dist/vue-it-bigger.min.css')

export default {
    components: {
		AddAcademy,
		EditAcademy,
        DeleteAcademy,
        LightBox
    },

    data() {
		return{
			popupAddAcademy: false,
			popupEditAcademy: false,
			popupDeleteAcademy: false,

			editAcademyId: 0,
            deleteAcademyId: 0,

            video: []
		}
	},

    
    computed: {
		academy() {
      		return {
                items: this.$store.state.posts.academy.map((robot, index) => {
                    return {
                        index: index,
                        id: robot.id,
                        thumb: robot.thumbnail,
                        sources: [
                        {
                            src: robot.url,
                            type: 'video/mp4'
                        }
                        ],
                        type: "video",
                        caption: `${robot.title}`,
                        width: `100%`,
                        height: 'auto',
                        autoplay: true,
                    }
                })
            }
    	}
    },
    
    created() {
        this.$vs.loading()
        this.$store.dispatch("getPosts","academy").then(() => {
            this.$vs.loading.close();
        }).catch(() => {
            this.$vs.loading.close()
            this.$vs.notify({
                title: '',
                text: 'خطا در اتصال به اینترنت',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            })
        })
    },

    methods: {
        srcFile(src) {
            return 'https://appapi.akambc.com/' + src
        },
        
        openVideo(index) {
            this.$refs.lightbox.showImage(index)
        },

        addAcademy(){
            this.popupAddAcademy = true
		},

		editAcademy(id){
			this.popupEditAcademy = true
			this.editAcademyId = id
		},
		
		deleteAcademy(id){
			this.popupDeleteAcademy = true
			this.deleteAcademyId = id
        },

        updatePopupAddAcademy(value){
            this.popupAddAcademy = value
		},

		updatePopupEditAcademy(value){
            this.popupEditAcademy = value
		},
		
		updatePopupDeleteAcademy(value){
            this.popupDeleteAcademy = value
        },
    }
}
</script>

<style>
.vib-container {
    z-index: 60000!important;
}
</style>

<style scoped>
.grid-view-item .grid-view-img{
    max-width: 100%;
    max-height: 100%;
    width: auto;
    transition: .35s;
}

.grid-view-item:hover {
    transform: translateY(-5px);
    box-shadow: 0px 4px 25px 0px rgba(0,0,0,.25);
}

.grid-view-item .grid-view-img{
    opacity: 0.9;
}

.item-view-primary-action-btn {
    color: #2c2c2c !important;
    background-color: #f6f6f6;
    min-width: 50%;
}

.item-view-secondary-action-btn {
    min-width: 50%;
}
</style>